/**
 * Created by JackCui on 2022/3/21
 */
import {getUserInfo} from '../store/local-catch/user'

// 获取当前登录人
export default getUserInfo